import { ref, toRaw } from "vue";
import apiClient from "@/services/api";
import { useErrorService } from "@/services/ErrorService";

export function useUpload() {
  const isLoading = ref(false);
  const error = ref(false);
  const error_message = ref("");
  const upload_response = ref(null);
  const errorSvc = useErrorService();

  async function runUpload(formState) {
    isLoading.value = true;
    error.value = false;
    error_message.value = "";
    upload_response.value = null;

    try {
      const formData = new FormData();
      formData.append("filename", formState.file.name);
      formData.append("title", `Dataset of ${formState.title}`);
      formData.append("description", formState.description);
      formData.append("is_open", String(formState.is_open));
      toRaw(formState.uploaders).forEach((author) =>
        formData.append("authors", JSON.stringify(author)),
      );
      formData.append("upload_type", formState.upload_type);

      const resp = await apiClient.sendSubmission(formData);
      const msg = resp.data?.message ?? {};
      const response = { ...msg, status: resp.status };
      upload_response.value = response;
      return response;
    } catch (err) {
      error.value = true;
      error_message.value = err?.message || "Upload failed";

      errorSvc.show("previewError", {
        title: "Preview Generation Failed",
        message:
          err?.response?.data?.message ??
          (err?.message
            ? `Preview failed: ${err.message}`
            : "An unknown error occurred while processing preview."),
        details: err?.stack,
      });

      throw err;
    } finally {
      isLoading.value = false;
    }
  }

  return { isLoading, error, error_message, upload_response, runUpload };
}
